import { INCOMING_SESSION, INCOMING_SESSION_SUCCESS, INCOMING_SESSION_ERROR, INCOMING_SESSION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const IncomingSession = (state = initialState, action) => {
  switch (action.type) {
    case INCOMING_SESSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case INCOMING_SESSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case INCOMING_SESSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case INCOMING_SESSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default IncomingSession;
